module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("What to do next . . .")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "timeline col-sm-6"
  }, _vm._l((_vm.toDos), function(toDo) {
    return (_vm.activeAccount.account_type === toDo.type) ? _c('div', {
      staticClass: "timeline-item"
    }, [_c('div', {
      staticClass: "timeline-badge"
    }, [_c('div', {
      staticClass: "timeline-icon"
    }, [_c('i', {
      class: [toDo.color, toDo.icon_class]
    })])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body"
    }, [_c('div', {
      staticClass: "timeline-body-arrow"
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-body-head"
    }, [_c('div', {
      staticClass: "timeline-body-head-caption"
    }, [_c('span', {
      staticClass: "timeline-body-alerttitle clickable",
      class: toDo.color,
      on: {
        "click": function($event) {
          _vm.startOnboarding(toDo.app, toDo.subApp)
        }
      }
    }, [_vm._v(_vm._s(toDo.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-body-content"
    }, [_c('span', {
      staticClass: "font-grey-cascade"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(toDo.text) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn blue margin-top-20",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.startOnboarding(toDo.app, toDo.subApp)
        }
      }
    }, [_vm._v("Get Started")])])])]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52542ba3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Dashboard.vue
// module id = 430
// module chunks = 1